/* eslint-disable */
import { Controller } from 'stimulus';
import { triggerCustomEvent } from 'lib/helpers';
import events from 'lib/events';

export default class SiteHeaderController extends Controller {
  static targets = [
    'mobileMenuBtn',
    'mobileMenuWrapper',
    'mobileMenuLinks',
    'mobileMenuClose'
  ]

  connect() {
    if (document.body.classList.contains('has-sticky-header')) {
      this.lastScrollTop = 0;
      this.searchTags = document.querySelector('.ez-search-tags');

      window.addEventListener('scroll', this.setStickyHeader);
    }
  }

  sendRelatedTagEvent(event) {
    const targetElement = event.target.closest('.ez-tags-carousel__tag-link');
    if (!targetElement) return;

    triggerCustomEvent(events.site_header.related_tag_click, {
      tagClicked: targetElement.getAttribute('title'),
      tagSearched: document.querySelector('#search').getAttribute('value')
    });
  }

  disconnect() {
    window.removeEventListener('scroll', this.setStickyHeader);
  }

  headerLogin() {
    triggerCustomEvent(events.site_header.header_login, {});
  }

  headerSignUp() {
    triggerCustomEvent(events.site_header.header_signup, {});
  }

  sendHeaderJoinProEvent() {
    triggerCustomEvent(events.site_header.header_join_pro, {});
  }

  setStickyHeader = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop === 0) {
      this.element.classList.remove('is-stuck');
    } else {
      if (!this.element.classList.contains('is-stuck')) {
        this.element.classList.add('is-stuck');
      }
    }

    if (this.searchTags) {
      if (scrollTop > this.lastScrollTop) {
        this.searchTags.classList.remove('scrollUp');
      } else {
        this.searchTags.classList.add('scrollUp');
      }

      this.lastScrollTop = scrollTop;
    }
  }

  populateMobileMenu = () => {
    let mobileLinksSelector = '.ez-site-header__app-link, .ez-site-header__join-pro';
    if (!document.querySelector('a.ez-btn--header-join-pro-btn')
        && !document.querySelector('.ez-site-header__main-nav.logged-out-nav')) {
      mobileLinksSelector = '.ez-site-header__app-link';
    }

    const mobileLinks = document.querySelectorAll(mobileLinksSelector);

    mobileLinks.forEach((link) => {
      const clonedLink = link.cloneNode(true);
      clonedLink.className = 'ez-site-header__mobile-menu-link';
      this.mobileMenuLinksTarget.appendChild(clonedLink);
    })
  }

  toggleMobileMenu = () => {
    if (this.mobileMenuLinksTarget.innerHTML === '') {
      this.populateMobileMenu()
      document.body.classList.add('mobile-menu-open');
    }
    else {
      document.body.classList.toggle('mobile-menu-open')
    }
  }
}
